export const FROM_DATE_SEARCH_PARAM = 'fromDate'
export const TO_DATE_SEARCH_PARAM = 'toDate'
export const YEAR_SEARCH_PARAM = 'year'
export const MONTH_SEARCH_PARAM = 'month'
